let docs

const setup = obj => {
	if (obj.docs) docs = obj.docs
}

export {setup, docs}
